// Static, hand-picked cover art for Super Narrate's genre/kids-band cards —
// one designed image per catalog id, bundled at build time (no AI
// generation, no network fetch). Swap/add files in
// frontend/src/assets/genre_icons/ and this map to change a genre's art.
import action from '../../../../assets/genre_icons/action.webp';
import adventure from '../../../../assets/genre_icons/adventure.webp';
import comedy from '../../../../assets/genre_icons/comedy.webp';
import documentary from '../../../../assets/genre_icons/documentary.webp';
import drama from '../../../../assets/genre_icons/drama.webp';
import explanation from '../../../../assets/genre_icons/explanation.webp';
import facts from '../../../../assets/genre_icons/facts.webp';
import horror from '../../../../assets/genre_icons/horror.webp';
import inANutshell from '../../../../assets/genre_icons/in_a_nutshell.webp';
import miniStory from '../../../../assets/genre_icons/mini_story.webp';
import podcast from '../../../../assets/genre_icons/podcast.webp';
import poem from '../../../../assets/genre_icons/poem.webp';
import preK from '../../../../assets/genre_icons/pre_k.webp';
import primary from '../../../../assets/genre_icons/primary.webp';
import realLifeStory from '../../../../assets/genre_icons/real_life_story.webp';
import rhymes from '../../../../assets/genre_icons/rhymes.webp';
import scifi from '../../../../assets/genre_icons/scifi.webp';
import thriller from '../../../../assets/genre_icons/thriller.webp';
import upperPrimary from '../../../../assets/genre_icons/upper_primary.webp';

const GENRE_ART = {
  action,
  adventure,
  comedy,
  documentary,
  drama,
  explanation,
  facts,
  horror,
  in_a_nutshell: inANutshell,
  mini_story: miniStory,
  podcast,
  poem,
  pre_k: preK,
  primary,
  real_life_story: realLifeStory,
  rhymes,
  scifi,
  thriller,
  upper_primary: upperPrimary,
};

export default GENRE_ART;
